export default __webpack_public_path__ + "src/components/EYTopNavBar/assets/EY_block.png";